var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.video !== undefined)?_c('v-card',{staticClass:"flex-grow-1"},[_c('v-card-title',[_vm._v(_vm._s(_vm.video.titulo))]),_c('v-card-text',{staticClass:"d-flex justify-center"},[_c('video-player',{key:"videoPlayer",attrs:{"options":_vm.videoOptions,"videoSrc":_vm.videoSrc}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }